<template>
  <div>
    <CRow>
      <CCol v-for="(target, index) in targets" :key="index">
        <CInputRadio
          type="radio"
          :id="target.name"
          :value="target.name"
          name="target"
          @update:checked="(b) => check(b, target.name)"
          :checked="actionSelected == target.name"
          class="cardChannel__checkRadio"
          :class="{
            'cardChannel__checkRadio--active': actionSelected == target.name,
          }"
          hidden
        />

        <div class="cardChannel__child m-1">
          <label :for="target.name" class="d-flex justify-content-center align-items-center flex-column p-2">
            <CIcon :name="target.name" :height="32" viewBox="0 0 32 32" />
            <span class="font-weight-normal font-md text-center"> {{ target.label }} </span>
          </label>
        </div>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import { CHANNEL_TYPES, FIELD_TYPE } from '../constants'

export default {
  name: 'AutomationAction',
  data() {
    return {
      actionSelected: null,
    }
  },
  mounted() {
    if (this.$store.state.automation.mainWorkflow.workflowJson.steps.values.length > 0) {
      switch (this.$store.state.automation.mainWorkflow.workflowJson.steps.values[0].type) {
        case CHANNEL_TYPES.SEND_SMS:
          this.actionSelected = 'sms'
          break
        case CHANNEL_TYPES.SEND_EMAIL:
          this.actionSelected = 'email'
          break
        default:
          break
      }
    }
  },
  computed: {
    targets() {
      return [
        {
          name: 'sms',
          label: this.$t('automation.action.option.001.label'),
          type: CHANNEL_TYPES.SEND_SMS,
          component: 'SendSms',
        },
        {
          name: 'email',
          label: this.$t('automation.action.option.002.label'),
          type: CHANNEL_TYPES.SEND_EMAIL,
          component: 'SendEmail',
        },
      ]
    },
  },
  methods: {
    check(_, name) {
      this.actionSelected = name
      let obj = { property: 'channelType', type: FIELD_TYPE.CONTROL }
      switch (name) {
        case 'sms':
          obj.value = CHANNEL_TYPES.SEND_SMS
          this.$store.commit('automation/SETUP_CONTENT_SMS')
          break
        case 'email':
          obj.value = CHANNEL_TYPES.SEND_EMAIL
          this.$store.commit('automation/SETUP_CONTENT_EMAIL')
          break
        default:
          break
      }
      this.$emit('update-field', obj)
    },
  },
}
</script>
